<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="javascript:void(0);" @click="$router.push('/lecture')" class="aHref">专家讲座</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>讲座详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="newLect flex">
                <div class=" img" :style="'backgroundImage: url('+details.thumbnailPath+')'"></div>
                <div class="rightC">
                    <h1 class="overflow">{{details.title}}</h1>
                    <div class="program">
                        <p><label class="line"></label>{{details.subTitle}}</p>
                    </div>
                    <div class="endTime">
                        <span>{{details.registerCount}}人已观看</span>
                    </div>
                </div>
            </div>
            <div class="detailCon">
                <div class="indicationsTit">
                    <span class="tit">讲座介绍</span>
                    <p>{{details.briefDesc}}</p>
                </div>
                <div class="indicationsTit">
                    <span class="tit">讲座专家</span>
                    <div class="expert flex">
                        <div class="swiperImg flex" v-for="(item,index) in details.doctors" :key="index">
                            <img :src="item.headImgPath" alt="" height="100%">
                            <div>
                                <strong>{{item.fullName}}</strong><br/>
                                <span>咨询专长：{{item.indications | indicationFmt}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="indicationsTit">
                    <span class="tit">讲座说明</span>
                    <p>{{details.explanation}}</p>
                </div>
            </div>
            <el-button class="joinUs" @click="videoPlay">立即观看</el-button>
        </div>


        <el-dialog width="760px"
                   :title="details.title"
                   :visible.sync="dialogVideo"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false"
                   :before-close="closeDialog">
         <video :src="details.videoPath" controls autoplay width="100%" ref="dialogVideoEle"></video>
        </el-dialog>

    </div>
</template>

<script>
    import base from '@/api/common';
    export default {
        name: "lectureDetail_video",
        data() {
            return {
                id: this.$route.query.id,
                details:{},

                isRegistered: 0,
                stateText:'',
                state: 0,

                dialogVideo: false
            }
        },
        mounted() {
            if(this.id){
                this.$ajax.get(base.api.expert.lecture.details_auth.replace("{id}",this.id)).then((res)=>{
                    if(res.data.status === 'success'){
                        this.details = res.data.data;
                    }
                }).catch((err)=>{
                    // 未登录
                    if(err.response.status === 401){
                        this.$ajax.get(base.api.expert.lecture.details_anyone.replace("{id}",this.id)).then((res)=>{
                            if(res.data.status === 'success'){
                                this.details = res.data.data;
                            }
                        })
                    }
                })
            }
        },
        methods: {
            videoPlay(){
                this.dialogVideo = true;
                // 观看人数增加
                this.$ajax.post(base.api.expert.lecture.videoViews.replace("{id}",this.id)).then((res)=>{
                });
			},
            closeDialog(done){
                this.$refs.dialogVideoEle.pause();
                done();
            },
        },
        filters:{
            dateFmt(item){
                if(item.startDate && item.endDate){
                    let s = new Date(item.startDate.replace(/-/g,"/"));
                    let e = new Date(item.endDate.replace(/-/g,"/"));

                    return s.Format("yyyy年MM月dd日 HH:mm:ss") + " - " + e.Format("yyyy年MM月dd日 HH:mm:ss");
                }
                return "-";
            },
            indicationFmt(indications){
                if (indications && indications.length > 0) {
                    let arr = [];
                    $(indications).each((i, o) => {
                        arr.push(o.cnName);
                    })
                    return arr.join("、");
                }
                return "";
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/medication.scss';

	.newCon {
		margin-top: 20px;
	}

	.endTime {
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #656565;

		span:last-child {
			color: #FB7B65;
		}
	}

	.joinUs[data-type='1'],.joinUs[data-type='1']:hover{
		color: #fff;
		background-color: #FFAD57;
		border-color: #FFAD57;}
	.joinUs[data-type='2'],.joinUs[data-type='2']:hover {
		color: #fff;
		background-color: #f56c6c;
		border-color: #f56c6c;
	}
	.joinUs[data-type='3'],.joinUs[data-type='3']:hover {
		color: #fff;
		background-color: #909399;
		border-color: #909399;
	}
</style>